import CommonFunctions from './common-functions';
export default class ProductSearch {
    constructor() {
        this.searchInputField = '[data-product-search-input]';
        this.dropDownContainer = '[data-product-search-dropdown]';
        this.pinnedSearchResultsContainer = document.querySelector('[data-pinned-search-results-container]');
        let commonfunctions = new CommonFunctions();
        this.addProductSearchKeyPressEventListener();
        this.closeSearchResultsDropDown();
        this.addProductSearchClickEventListener();
        this.addClearSearchInputEventListener();
        this.searchHeaderToggle();
        document.addEventListener('click', commonfunctions.closeAllSelect);
        if (this.pinnedSearchResultsContainer) {
            this.togglePinnedSearchResults('');
            this.pinnedSearchResultsContainer.classList.remove('hide');
        }
    }

    addProductSearchKeyPressEventListener() {
        let timeout;
        const humanize = 200;
        let commonfunctions = new CommonFunctions();
        document.querySelector(this.searchInputField).addEventListener('keyup', (event) => {
            const value = event.target.value;
            const dropDownContainer = document.querySelector(this.dropDownContainer);
            this.togglePinnedSearchResults(value);
            if (!value) {
                dropDownContainer.classList.add('hide');
                dropDownContainer.classList.remove('show');
                return;
            }

            if (timeout) {
                clearTimeout(timeout);
            }
            const dealType = 'all';
            timeout = setTimeout(function() {
                commonfunctions.populateNullOrLoadingText(dropDownContainer, true);
                commonfunctions.makeRequest(dealType, value, dropDownContainer);
            }, humanize);
        });
    }

    closeSearchResultsDropDown() {
        let dropdownSelector = document.querySelector(this.dropDownContainer);
        let searchInputField = document.querySelector(this.searchInputField);
        document.addEventListener('click', function(event) {
            let isClickInsideDropdown = dropdownSelector.contains(event.target);
            let isClickInsideSearchInput = searchInputField.contains(event.target);
            if (isClickInsideDropdown || (isClickInsideSearchInput && searchInputField.value)) {
                dropdownSelector.classList.add('show');
                dropdownSelector.classList.remove('hide');
            } else {
                dropdownSelector.classList.remove('show');
                dropdownSelector.classList.add('hide');
            }
        });
    }

    addProductSearchClickEventListener() {
        let searchInputField = document.querySelector(this.searchInputField);
        let dropdownSelector = document.querySelector(this.dropDownContainer);
        searchInputField.addEventListener('click', (event) => {
            const value = event.target.value;
            if (value) {
                dropdownSelector.classList.add('show');
                dropdownSelector.classList.remove('hide');
            }
        });
    }

    searchHeaderToggle() {
        document.querySelectorAll("a[data-target='#search']").forEach((selectedItem) => {
            selectedItem.addEventListener('click', function() {
                document.querySelector('body').classList.toggle('header-search-active');
            });
        });
    }

    togglePinnedSearchResults(value) {
        value = value.trim().toLowerCase();
        this.pinnedSearchResultsContainer.querySelectorAll('a').forEach((pinnedSearchResult) => {
            const state = value.length < 2 || pinnedSearchResult.dataset.searchTerms.toLowerCase().search(value) < 0;
            pinnedSearchResult.classList.toggle('hide', state);
            if (pinnedSearchResult.parentElement.dataset.hasOwnProperty('pinnedSearchResultGroup')) {
                pinnedSearchResult.parentElement.classList.toggle('hide', state);
            }
        });
    }

    addClearSearchInputEventListener() {
        document.querySelector('.search-form .srchDlt').addEventListener('click', () => {
            this.togglePinnedSearchResults('');
        });
    }
}
